<template>
  <v-window class="mb-4">
    <v-img src="/image/legal/terms-of-use.jpg" id="landing-section">
      <v-layout row style="height: 100%">
        <v-layout align-center justify-center>
          <v-flex xs12>
            <v-card color="transparent" flat>
              <v-card-text>
                <h3 id="slogan" class="text-xs-center white--text text-shadow">
                  TÉRMINOS Y CONDICIONES DE USO DEL SERVICIO WESMARTPARK
                </h3>
                <h4
                  id="subslogan"
                  class="text-xs-center white--text text-shadow mt-3"
                >
                  Martes 15 de diciembre de 2020, Barcelona.
                </h4>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-img>

    <template>
      <div v-waypoint="{ active: true, callback: onWaypoint }"></div>
    </template>

    <v-container>
      <p>Hola, ¿cómo estás?</p>
      <p>
        Ante todo, muchas gracias por usar el servicio wesmartPark (WSP), todo
        el equipo que hay detrás vamos a trabajar duro para que te sea útil y te
        ayude.
      </p>
      <p>
        Este documento contiene los términos y condiciones de uso de WSP, y
        tiene carácter contractual, o sea que define tus derechos y obligaciones
        como cliente de WSP.
      </p>
      <p>
        Acostumbran a ser documentos tediosos y complejos, como en WSP nos
        gustan las cosas sencillas lo vamos a redactar de modo sencillo, y te
        recomendamos leerlo completo, caso que tengas alguna pregunta, no dudes
        en contactarnos.
      </p>
      <p class="mb-0 mt-3">
        Los motivos de actualizar los Términos y condiciones de uso son:
      </p>
      <ol>
        <li>
          Nueva Tecnología de acceso Bluetooth que modifica el proceso de
          registro y de uso de las instalaciones de aparcamiento WSP, este es el
          motivo principal.
        </li>
        <li>
          Aprovechando el motivo principal, redactar de forma más clara y
          completa el resto de las condiciones, sin que ello signifique cambio
          alguno con las anteriores.
        </li>
      </ol>
      <p class="mb-0 mt-3">El presente documento tiene 2 partes:</p>
      <ol>
        <li>
          Terminología: resumen y definición de palabras específicas del
          servicio WSP.
        </li>
        <li>Términos y condiciones de uso del servicio WSP.</li>
      </ol>
      <p class="mt-3">Bienvenid@ y recibe un fuerte abrazo del equipo WSP!</p>
      <h1 class="mt-5 primary--text">Terminología</h1>
      <h2 class="mt-2">
        Resumen de palabras, que usamos en los Términos y Condiciones de uso, a
        las que quizá no estés acostumbrad@:
      </h2>
      <ul>
        <li>
          <b>Usuario:</b>
          persona que se ha registrado, convirtiéndose en cliente de la empresa
          NPU, y que utiliza el servicio WSP para aparcar de acuerdo con las
          condiciones de uso.
        </li>
        <li>
          <b>Propietario:</b>
          titular de una o más plazas de estacionamiento de la red WSP, sujetas
          a lo que prevé la ley 40/2002 de 14 de noviembre, Reguladora del
          Contrato de Aparcamiento de Vehículos.
        </li>
        <li>
          <b>Perfil de Usuario:</b>
          espacio habilitado por NPU en la plataforma web WSP, que contiene los
          datos proporcionados por los usuarios, en el que éstos pueden
          guardarlos, consultarlos y modificarlos; así como interactuar,
          participar, y contratar en el servicio WSP.
        </li>
        <li>
          <b>Perfil de Gestión:</b>
          espacio habilitado por NPU en la plataforma web WSP, que contiene los
          datos proporcionados por los propietarios, en el que éstos pueden
          guardarlos, consultarlos y modificarlos; así como interactuar y
          modificar la disponibilidad que ofrecen de sus plazas al servicio WSP.
        </li>
        <li>
          <b>Tecnología de acceso:</b>
          medios tecnológicos que NPU proporciona al usuario para que este pueda
          acceder a los estacionamientos de la red WSP. Pueden ser la Pegatina o
          Teletag, o el bluetooth del propio móvil del usuario.
        </li>
        <li>
          <b>Pegatina o teletag:</b>
          etiqueta adhesiva (TAG pasivo RFID) que se vincula al Perfil del
          usuario. Su finalidad es permitir la entrada y salida del vehículo de
          los estacionamientos WSP. Se debe colocar en el parabrisas del
          vehículo de acuerdo con las instrucciones que NPU indica en el
          folleto.
        </li>
        <li>
          <b>Pantalla de Control:</b>
          equipo electrónico instalado por NPU en los estacionamientos WSP con
          asignación de plaza; consiste en una pantalla táctil y su función es
          indicar al usuario la plaza que debe ocupar.
        </li>
        <li>
          <b>Teclado numérico:</b>
          equipo electrónico instalado por NPU en los estacionamientos WSP;
          consiste en un teclado numérico y su función es permitir el acceso a
          pie del usuario para que pueda recoger su vehículo, debiendo para
          ello, introducir el número de móvil indicado durante su registro.
        </li>
        <li>
          <b>Zona WSP:</b>
          zona, dentro de un estacionamiento WSP, en dónde se encuentras las
          plazas gestionadas por el servicio WSP. Se puede llegar a ellas, desde
          la entrada del estacionamiento, siguiendo la cartelería instalada por
          NPU. El usuario podrá identificar las plazas WSP y su número, por los
          carteles y los sensores de presencia instalados en ellas.
        </li>
        <li>
          <b>Ocupación:</b>
          espacio de tiempo durante el cual el vehículo del usuario permanece
          estacionado en una plaza WSP.
        </li>
        <li>
          <b>Disponibilidad:</b>
          espacio de tiempo que el Propietario de la plaza indica, en su Perfil
          de Gestión, que está puede utilizarse por los usuarios del servicio
          WSP.
        </li>
        <li>
          <b>Saldo:</b>
          cantidad de dinero que el usuario puede usar en los estacionamientos
          de la red WSP. A medida que vaya contratando servicios y
          consumiéndolos, el importe de estos se irá deduciendo del Saldo a
          razón de la tarifa de cada servicio contratado.
        </li>
        <li>
          <b>Paquetes de horas:</b>
          productos, que el usuario compra en su Perfil de usuario, para reponer
          el Saldo consumido al aparcar en los estacionamientos de la red WSP.
        </li>
        <li>
          <b>Reserva:</b>
          servicio de estacionamiento de corta duración ofrecido por NPU en los
          estacionamientos WSP. Estos se tarificarán por minutos a razón de la
          Tarifa Normal o la Tarifa Extra.
        </li>
        <li>
          <b>Abono:</b>
          servicio de estacionamiento de larga duración ofrecido por NPU en los
          estacionamientos WSP. Estos se tarificarán a razón del tipo de Abono
          contratado por el usuario.
        </li>
        <li>
          <b>Tarifa Normal:</b>
          tarifa que se aplica al usuario por Ocupaciones que respeten el Tiempo
          Límite, en caso de que exista. Las unidades de esta tarifa son euros
          por minuto.
        </li>
        <li>
          <b>Tarifa Extra:</b>
          tarifa que se aplica al usuario por Ocupaciones que excedan el Tiempo
          Límite, en caso de que exista. Las unidades de esta tarifa son euros
          por minuto.
        </li>
        <li>
          <b>Tiempo Límite:</b>
          aviso que puede aparecer al usuario durante el proceso de contratación
          de una Reserva. Esta limitación puede ser debida a:
          <ol>
            <li>que el estacionamiento cierra,</li>
            <li>el propietario quiere recuperar su plaza o</li>
            <li>
              ya hay reservas de otros usuarios. Si el usuario no respeta el
              Tiempo Límite, causará una molestia a un Propietario o a otro
              usuario, y se le aplicará la Tarifa Extra por el período que
              permanezca posterior al Tiempo Límite.
            </li>
          </ol>
        </li>
        <li>
          <b>Recolocación:</b>
          cuando un usuario no respeta el Tiempo Límite, puede afectar a
          Reservas de otros usuarios. Como la plaza WSP no está libre, por abuso
          de un usuario, NPU recolocará a los usuarios afectados en otras plazas
          del propio estacionamiento, pero si no es posible, recolocará en otros
          estacionamientos WSP; para ello avisará al usuario afectado mediante
          el envío de correo electrónico y SMS a la dirección electrónica y
          número de móvil indicado en el registro. En el aviso, NPU ofrecerá al
          usuario otra opción de estacionar si la hubiera en un radio de 400
          metros alrededor de la opción escogida por este.
        </li>
        <li>
          <b>Ticket:</b>
          factura simple de cada servicio contratado y consumido por el usuario
          dentro de los estacionamientos de la red WSP.
        </li>
      </ul>
      <h1 class="mt-5 primary--text">
        Términos y Condiciones de Uso del servicio WSP
      </h1>
      <p>
        WeSmartPark (en adelante WSP) es el nombre comercial del servicio de
        parksharing (aparcamiento compartido) ofrecido por la empresa Nous
        Pàrquings Urbans, S.L. (en adelante NPU).
      </p>
      <p>
        El servicio WSP ofrece al usuario la posibilidad, partiendo de sus
        necesidades o preferencias concretas respecto a lugar, fecha y hora de
        entrada; de reservar un espacio destinado a estacionamiento; cuya
        titularidad ostenta un tercero llamado Propietario ofreciendo su espacio
        cuando este no lo necesita.
      </p>
      <p>
        El documento presente tiene carácter contractual y rige las relaciones
        entre las partes en la contratación de servicios a través del dominio
        <a href="https://www.wesmartpark.com" target="blank"
          >https://ww.wesmartpark.com</a
        >, y sus aplicaciones móviles para sistemas operativos Android y iOS,
        propiedad de NPU.
      </p>
      <p>
        Existen, a efectos del procedimiento de alta y contratación, versiones
        en catalán, castellano e inglés. En caso de discrepancia, la versión
        castellana de los Términos y Condiciones de Uso prevalecerá sobre las
        versiones en otros idiomas.
      </p>
      <p class="mb-0 mt-3">
        La aceptación de este documento implica que el usuario:
      </p>
      <ol>
        <li>Ha leído lo expuesto a continuación y lo comprende.</li>
        <li>
          Es una persona con capacidad suficiente para contratar y consiente en
          hacerlo.
        </li>
        <li>Asume todas las obligaciones enumeradas en este contrato.</li>
      </ol>
      <h2 class="mt-5 primary--text">1. Prestador del servicio WSP:</h2>
      <p>
        El prestador del servicio WSP es la mercantil Nous Pàrquings Urbans,
        S.L. (en adelante NPU) con domicilio social en Calle Gran Via de les
        Corts Catalanes, 911-917 local comercial bajos (08018) de Barcelona y
        CIF B65798548, inscrita en el Registro Mercantil de Barcelona con
        escritura de constitución de sociedad, otorgada por el Notario de
        Barcelona, D. José Rivas Guardo el día 10 de Mayo de 2012, obrante al
        núm. 795 de su protocolo; presta al usuario los servicios descritos en
        el presente documento.
      </p>
      <p>
        El inicio de la prestación del servicio estará condicionado al correcto
        registro y alta del usuario en la plataforma NPU, así como a la
        aceptación de las condiciones del presente contrato, y,
        consecuentemente, a su celebración.
      </p>
      <h2 class="mt-5 primary--text">
        2. Precios, tarifas y servicios ofrecidos:
      </h2>
      <p>
        El usuario tendrá conocimiento de los precios y tarifas vigentes a
        través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS., que,
        junto con sus modificaciones, tendrán la consideración de parte
        integrante del mismo. La modificación de los precios y tarifas de los
        servicios aplicables se comunicará a través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS.
      </p>
      <p>
        La información relativa a los precios y tarifas podrá obtenerse,
        igualmente, en los teléfonos de atención al cliente visibles en la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS.
      </p>
      <p>
        La modificación de los precios y tarifas nunca podrá aplicarse con
        carácter retroactivo, es decir, a servicios contratados y/o realizados
        con anterioridad a la publicación de la modificación. Los servicios que
        ofrece NPU son:
      </p>
      <h3>Servicio de estacionamiento de corta duración:</h3>
      <ul>
        <li>
          Para referirnos a los estacionamientos de corta duración se usará el
          término “Reserva”
        </li>
        <li>
          Para disfrutar del servicio, el usuario deberá contratarlo a través de
          la web
          <a href="https://www.wesmartpark.com" target="blank"
            >www.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS,
          obtener la confirmación de la Reserva y estar en posesión de la
          Tecnología de acceso.
        </li>
        <li>
          El usuario dispondrá de un margen de tiempo para dirigirse al
          estacionamiento una vez formalizada la Reserva. Pudiendo acceder al
          estacionamiento treinta (30) minutos antes de la hora de inicio
          indicada por el usuario, y treinta (30) minutos después de la hora de
          inicio indicada por el usuario; al superarse este tiempo la reserva se
          anulará automáticamente.
        </li>
        <li>
          Se cobrará al usuario por los minutos que haya permanecido estacionado
          en un estacionamiento del servicio WSP.
        </li>
        <li>
          La duración del estacionamiento se computará a través de las lecturas
          de entrada y salida del vehículo del usuario, estás lecturas serán
          efectuadas por los equipos electrónicos que NPU ha instalado en el
          estacionamiento asociado al servicio.
        </li>
        <li>
          El cobro de este servicio será deducido del Saldo del que disponga el
          usuario en su perfil, y que este ha comprado con anterioridad.
        </li>
        <li>
          La contratación de este servicio se podrá hacer desde la web y las
          aplicaciones móviles de NPU, para ello el usuario deberá iniciar
          sesión y acceder a su Perfil de Usuario.
        </li>
        <li>
          El usuario no podrá contratar este servicio cuando su Saldo sea igual
          a cero o negativo.
        </li>
        <li>
          El usuario podrá consultar las tarifas en vigor, los detalles del
          estacionamiento y cualquier otra información relevante, que afecte a
          su Reserva, en el momento de contratar el servicio a través de la web
          <a href="https://www.wesmartpark.com" target="blank"
            >www.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          Este servicio se puede facturar mediante 2 tarifas: Tarifa Normal y
          Tarifa Extra, la aplicación de una u otra, dependerá que el usuario
          respete el Tiempo Límite del estacionamiento si este lo tuviera.
        </li>
        <li>
          Caso que el estacionamiento tuviera una limitación horaria, esta será
          notificada al usuario previamente de aceptar la contratación del
          servicio, debiendo ser aceptada por parte del usuario para su
          contratación.
        </li>
        <li>
          Durante el tiempo que el usuario este estacionado sin rebasar el
          Tiempo Límite, el servicio se facturará a razón de la Tarifa Normal,
          caso que el usuario rebase el Tiempo Límite, este período se facturará
          a razón de la Tarifa Extra.
        </li>
      </ul>
      <br />
      <h3>Servicio de estacionamiento de larga duración:</h3>
      <ul>
        <li>
          Para referirnos a los estacionamientos de larga duración se usará el
          término “Abono”
        </li>
        <li>
          Para disfrutar del servicio, el usuario deberá contratarlo a través de
          la web
          <a href="https://www.wesmartpark.com" target="blank"
            >www.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS,
          obtener la confirmación del Abono y estar en posesión de la Tecnología
          de acceso.
        </li>
        <li>Se cobrará al usuario por el importe del abono que este escoja.</li>
        <li>
          La duración del abono será función de la tipología escogida por el
          usuario.
        </li>
        <li>
          El usuario podrá consultar las tarifas en vigor, los detalles del
          estacionamiento y cualquier otra información relevante, que afecte a
          su Abono, en el momento de contratar el servicio a través de la web
          <a href="https://www.wesmartpark.com" target="blank"
            >www.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          El cobro de este servicio se realizará al momento de su contratación
          por parte del usuario. Su importe no se deduce del Saldo del que
          disponga el usuario en su perfil.
        </li>
        <li>
          Una vez comprado un abono no se puede cancelar, y no se admite
          devolución del importe.
        </li>
        <li>
          Si el usuario llega antes de la hora de inicio del abono, o sale
          después de su hora de finalización; se le creará automáticamente una
          Reserva por el período que siga estacionado; facturando durante este
          período a razón de la Tarifa Normal o de la Tarifa Extra según proceda
          de acuerdo con las Condiciones de uso.
        </li>
        <li>
          Durante el tiempo que un Abono este en vigor, el usuario podrá salir y
          entrar del estacionamiento las veces que necesite.
        </li>
        <li>
          El hecho de que un estacionamiento disponga o no de abonos, su
          tipología, cantidad e importe; será función del Propietario de cada
          estacionamiento, quién los habilita directamente en su Perfil de
          Propietario.
        </li>
        <li>
          La contratación de este servicio se podrá hacer desde la web y las
          aplicaciones móviles de WSP, para ello el usuario deberá iniciar
          sesión y acceder a su Perfil de Usuario.
        </li>
        <li>
          Las tipologías de Abono que el usuario puede contratar son:
          <ol>
            <li>
              Nocturno: válido para períodos comprendidos entre las 20:00 y las
              08:00.
            </li>
            <li>
              Diario: con duración de 24 horas, a contar des de la fecha y hora
              de inicio indicadas por el usuario en el momento de su
              contratación.
            </li>
            <li>
              Semanal: con duración de 168 horas (7 días * 24 horas/día), a
              contar des de la fecha y hora de inicio indicadas por el usuario
              en el momento de su contratación.
            </li>
            <li>
              Mensual: con duración de 720 horas (30 días * 24 horas/día), a
              contar des de la fecha y hora de inicio indicadas por el usuario
              en el momento de su contratación.
            </li>
          </ol>
        </li>
        <li>
          NPU se reserva el derecho de crear nuevas tipologías o modificar las
          existentes. En cualquier caso, el usuario conocerá con total
          transparencia las condiciones de los Abonos antes de su contratación.
        </li>
      </ul>
      <h2 class="mt-5 primary--text">3. Política de Recolocaciones:</h2>
      <p>
        Existe la posibilidad que la Reserva o Abono contratados por un usuario
        no puedan ser disfrutadas por el usuario debido a que otro usuario no
        haya respetado el Tiempo Límite de su Reserva.
      </p>
      <p>
        En el supuesto que por abusos no imputables a NPU, ya sea por parte de
        otros usuarios o de propietarios, NPU no pueda mantener la reserva
        efectuada a un usuario, NPU le proporcionará en el menor tiempo posible,
        otras alternativas lo más similares posible a sus requisitos de búsqueda
        inicial. Este proceso se llama Recolocación.
      </p>
      <p>
        En este caso, la Reserva inicial quedará automáticamente anulada; y no
        se considerará aceptada cualquiera de las posibilidades alternativas
        ofrecidas por NPU, hasta que el usuario no formalice y confirme la nueva
        Reserva expresamente, y a través de los medios que a tal efecto
        proporciona NPU.
      </p>
      <h2 class="mt-5 primary--text">4. Política de cancelaciones:</h2>
      <p>
        A todos nos surgen imprevistos, de modo que NPU ofrece por defecto al
        usuario la posibilidad de cancelar sus Reservas sin cargo alguno para el
        usuario.
      </p>
      <p>
        NPU quiere hacer constar que al conceder una Reserva un usuario, está
        bloqueando un espacio de estacionamiento para que pueda ser usado por
        este; impidiendo que otros usuarios puedan usarlo.
      </p>
      <p>
        Caso que, el usuario abuse de este atributo y en más de seis (6)
        ocasiones al año no cancele las Resrervas que no vaya a consumir, NPU se
        reserva el derecho a aplicar un cargo al usuario de 6€ por cada Reserva
        no cancelada a menos de tres (3) horas de su inicio.
      </p>
      <p>Este cargo será deducido directamente del Saldo del usuario.</p>
      <h2 class="mt-5 primary--text">5. Saldo:</h2>
      <p>
        El importe consumido por las Reservas contratadas por el usuario se
        deducirá del Saldo que ha comprado previamente y que puede consultar en
        su Perfil de Usuario, a través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS. El
        usuario podrá aumentar su Saldo mediante la compra de Paquetes de horas,
        a través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS.
      </p>
      <p>
        Para la compra de Paquetes de horas el usuario deberá introducir su
        tarjeta de crédito o débito, y la compra se ejecutará a través del
        comercio virtual que NPU tiene contratado con Banc de Sabadell. NPU no
        guarda ningún dato de la tarjeta de crédito, todos estos datos son
        guardados en el TPV del Banc de Sabadell.
      </p>
      <p>
        NPU puede modificar, en cualquier momento y de modo unilateral, la
        entidad bancaria con la que actualmente tiene contratado el comercio
        virtual para que el usuario realice la compra de Paquetes de horas.
      </p>
      <p>
        El Saldo comprado no tiene caducidad, pudiendo ser consumido en los
        parkings de la red WSP mediante la contratación de los servicios
        descritos en el presente documento. Ello no será válido para el Saldo
        regalado a los usuarios en forma de promociones que, por norma general,
        deberá ser consumido en los siguientes tres (3) meses a contar desde su
        recepción; a no ser que en la promoción se indiquen otras condiciones.
      </p>
      <p>
        El Saldo comprado no es reembolsable y debe ser consumido en los
        parkings de la red WSP mediante la contratación de los servicios
        descritos en el presente documento. Caso que el usuario no quiera
        consumirlo, tiene la opción de transferir su saldo a otro usuario del
        servicio. El usuario podrá consultar, en todo momento, los movimientos
        de su Saldo a través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS.
      </p>
      <p>
        Dado que, al salir de un estacionamiento, el importe de la duración sea
        superior al Saldo del usuario, se le permitirá la salida del
        estacionamiento; quedando su Saldo en valor negativo y generando una
        deuda en favor de NPU.
      </p>
      <p>
        En el momento de la salida del estacionamiento, el usuario recibirá una
        notificación por correo de que su Saldo ha quedado en negativo, y podrá
        liquidar la deuda a través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS.
      </p>
      <p>
        Si un usuario no regulariza su Saldo negativo en un período de tres (3)
        meses, será dado de baja del servicio WSP sin posibilidad de volver a
        registrarse en el mismo.
      </p>
      <p>
        NPU le mandará periódicamente comunicaciones, vía correo electrónico o
        notificaciones, recordándole que debe regularizar su Saldo y
        ofreciéndole medios para ello.
      </p>
      <p>
        NPU se reserva el derecho de proceder por todos los medios disponibles
        para reclamar el importe pendiente más el coste que en qué pudiera
        incurrir para conseguir su recuperación.
      </p>
      <h2 class="mt-5 primary--text">6. Tickets y facturas:</h2>
      <p>
        Por cada servicio de Reserva, Abono y compra de Paquetes de horas se
        generará automáticamente un Ticket que tendrá el carácter de factura
        simple.
      </p>
      <p>
        El usuario podrá consultar en todo momento y descargarse en formato PDF,
        los Tickets de los servicios consumidos, ya sea de modo individual o por
        períodos de tiempo.
      </p>
      <p>
        Las consultas y descargas de Tickets se realizan a través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS, para
        ello el usuario deberá iniciar sesión y acceder a su Perfil de Usuario.
      </p>
      <p>
        Independientemente de los Tickets generados automáticamente, el usuario
        podrá solicitar factura de las compras de Paquete de horas y Abonos.
      </p>
      <p>
        Para solicitar las facturas, el usuario deberá registrarse como
        “Empresa”, a través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS, a fin
        de proporcionar la información fiscal necesaria para generar la factura,
        y el correo electrónico dónde quiere recibirlas.
      </p>
      <p>
        Las facturas se enviarán el día 7 de cada mes, al correo electrónico
        indicado por el usuario, y recogerán todas las compras de Paquetes de
        horas y consumo de Abonos realizados por el usuario el mes anterior.
      </p>
      <h2 class="mt-5 primary--text">7. Baja del servicio WSP:</h2>
      <p>
        El usuario podrá darse de baja del servicio en cualquier momento a
        través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS. Se
        recuerda que, el Saldo existente en el Perfil de usuario en el momento
        de darse de baja no es reembolsable.
      </p>
      <p class="mb-0 mt-3">El usuario tiene las siguientes opciones:</p>
      <ol>
        <li>Consumirlo antes de darse de baja.</li>
        <li>Transferirlo a otro usuario que indique.</li>
        <li>Renunciar a él en favor de NPU.</li>
      </ol>
      <p class="mt-3">
        La baja del servicio equivale a la resolución del presente contrato
        entre el usuario y NPU. No obstante, la resolución del contrato no
        eximirá a las partes del fiel cumplimiento de las obligaciones que
        queden pendientes del mismo.
      </p>
      <h2 class="mt-5 primary--text">
        8. Correos electrónicos y notificaciones:
      </h2>
      <p>
        NPU usará correos electrónicos y notificaciones automáticas para
        comunicarse con el usuario. El motivo de las comunicaciones será,
        únicamente, para trasladarle novedades y asuntos relacionados con los
        servicios ofrecidos y contratados.
      </p>
      <p>
        El usuario podrá darse de baja de las comunicaciones en todo momento a
        través de la web
        <a href="https://www.wesmartpark.com" target="blank"
          >www.wesmartpark.com</a
        >
        y sus aplicaciones móviles para sistemas operativos Android y iOS; no
        obstante, este hecho eximirá a NPU de cualquier responsabilidad ante una
        reclamación por parte del usuario debida a la no recepción de las
        comunicaciones.
      </p>
      <p>
        Como último recurso y de modo excepcional, si NPU requiere comunicarse
        con el usuario de forma urgente por motivos relacionados con el servicio
        WSP, se reserva el derecho de realizar una llamada telefónica al número
        de móvil que este ha proporcionado durante su registro.
      </p>
      <h2 class="mt-5 primary--text">9. Formas de contacto con NPU:</h2>
      <p class="mb-0">
        NPU pone a disposición del usuario los siguientes canales de
        comunicación:
      </p>
      <ol>
        <li>
          Teléfono horario oficina (laborables de 09:00 a 17:00): +34 932 246
          023
        </li>
        <li>
          Teléfono emergencias (festivos y fuera horario oficina): +34 902 676
          836
        </li>
      </ol>
      <p class="mt-3">
        Caso que el usuario deba usar el teléfono de emergencias, y el motivo de
        la llamada sea imputable a un fallo del servicio WSP, NPU asumirá el
        coste de la llamada descontándolo del importe del servicio o abonándolo
        en forma de Saldo.
      </p>
      <p>
        En la atención telefónica, NPU verificará la correcta identificación del
        usuario; caso que este no consiga identificarse correctamente no se le
        atenderá.
      </p>
      <p class="mb-0 mt-3">
        NPU también dispone de otros canales de comunicación:
      </p>
      <ol>
        <li>
          Correo electrónico:
          <a href="mailto:info@wesmartpark.com">info@wesmartpark.com</a>
        </li>
        <li>Canales Sociales: Facebook, Twitter, LinkedIn e Instagram.</li>
      </ol>
      <p class="mb-0 mt-3">Tiempos de atención y respuesta:</p>
      <ol>
        <li>
          Telefónicamente 24/7 y respuesta al momento a menos que estemos
          atendiendo a otros usuarios.
        </li>
        <li>
          Por correo electrónico laborables de 09:00 a 15:00 y respuesta en
          máximo de 48 horas.
        </li>
        <li>
          Por Canales Sociales laborables de 09:00 a 15:00 y respuesta en máximo
          de 48 horas.
        </li>
      </ol>
      <p class="mt-3">
        Se recomienda al usuario usar los canales de comunicación de modo
        coherente con la urgencia de respuesta esperada por parte de NPU.
      </p>
      <h2 class="mt-5 primary--text">10. Obligaciones de NPU:</h2>
      <p class="mb-0">
        NPU, en la prestación del servicio WSP, asume ante el usuario las
        siguientes obligaciones:
      </p>
      <ol>
        <li>
          NPU se obliga a prestar los servicios de acuerdo con los Términos y
          Condiciones de Uso, y emplear todos los medios necesarios para el
          restablecimiento de estos, caso de verse interrumpidos por un fallo a
          ella imputable.
        </li>
        <li>
          NPU se obliga a informar al usuario, con un (1) mes de antelación, de
          la variación de los Términos y Condiciones de Uso.
        </li>
        <li>
          NPU se obliga a garantizar el secreto de los datos personales
          proporcionados por el usuario. No obstante, NPU quedará exonerada de
          esta responsabilidad si la obtención de los datos, por un usuario o
          tercero, se produce como consecuencia de actos que no les sean
          atribuibles, o hayan sido obtenidos a través de procesos fuera del
          control que pueda llevar a cabo NPU.
        </li>
        <li>
          NPU se obliga a facilitar al usuario las aclaraciones que este
          solicite en cuanto a: a) los Términos y Condiciones de Uso, b)
          Facturación y consumos.
        </li>
        <li>
          NPU se obliga a ofrecer al usuario canales de comunicación con NPU,
          ágiles y 24/7, para resolver posibles incidencias derivadas del uso
          del servicio.
        </li>
        <li>
          NPU se obliga a poner a disposición del usuario Hojas de Reclamación.
        </li>
        <li>
          NPU se obliga a tener una póliza de responsabilidad civil en vigor, y
          con cobertura suficiente para hacer frente a los daños que haya podido
          causar al usuario durante la prestación del servicio por hechos a ella
          imputables.
        </li>
      </ol>
      <h2 class="mt-5 primary--text">11. Obligaciones del usuario:</h2>
      <p class="mb-0">
        La utilización del servicio WSP por parte del usuario, supone la
        asunción de las siguientes obligaciones:
      </p>
      <ol>
        <li>
          El usuario se obliga a disponer, en todo momento durante el uso del
          servicio WSP, de un móvil operativo que se corresponda con el número
          facilitado por el usuario en el registro.
        </li>
        <li>
          El usuario se obliga a disponer y custodiar la Tecnología de acceso
          para poder acceder a los estacionamientos de la red WSP.
        </li>
        <li>
          Caso que lo hubiera, el usuario se obliga a respetar el Tiempo Límite
          especificado en su Reserva. De no hacerlo, asume que le sea de
          aplicación la Tarifa Extra por el período que exceda el Tiempo Límite.
          Caso que el usuario exceda el Tiempo Límite en más de cuatro (4)
          ocasiones, generado prejuicios en otros usuarios o propietarios, NPU
          se reserva el derecho a dar de baja al usuario del servicio WSP.
        </li>
        <li>
          El usuario se obliga a hacer un buen uso de las instalaciones del
          estacionamiento; siendo responsable de los daños que pudiera causar
          tanto en la estructura y/o mobiliario del estacionamiento, como en
          otros vehículos estacionados en el mismo.
        </li>
        <li>
          El usuario se obliga y responsabiliza de la veracidad de los datos e
          información que proporciona durante su registro o que introduzca a
          posterioridad en su Perfil de Usuario.
        </li>
        <li>
          El usuario se obliga a mantener su Saldo en valor positivo o cero (0).
          7. Se obliga a tener una póliza de seguros en vigor para hacer frente
          a los daños que haya podido causar durante el uso del servicio.
        </li>
        <li>
          El usuario se obliga a cancelar las Reservas que no vaya a consumir
          con una anterioridad mínima de 2 horas respecto a su inicio.
        </li>
      </ol>
      <h2 class="mt-5 primary--text">12. Modificaciones del servicio:</h2>
      <p>
        La modificación, por parte de NPU, de las Condiciones de Uso, facultará
        al usuario para poder darse de baja del servicio.
      </p>
      <p>
        La baja del servicio equivale a la resolución del presente contrato
        entre el usuario y NPU. No obstante, la resolución del contrato no
        eximirá a las partes del fiel cumplimiento de las obligaciones que
        queden pendientes del mismo.
      </p>
      <p>
        Se recuerda que, el Saldo existente en el Perfil de usuario en el
        momento de darse de baja no es reembolsable.
      </p>
      <h2 class="mt-5 primary--text">13. Reclamaciones:</h2>
      <p>
        El usuario podrá formular sus quejas o reclamaciones mediante los
        formularios oficiales que NPU pone a su disposición en sus oficinas,
        situadas en: Gran Via de les Corts Catalanes, 911- 917 local comercial
        bajos (08018) de Barcelona.
      </p>
      <p>
        Caso que el usuario no pueda desplazarse a las oficinas de NPU, este
        puede realizar su queja o reclamación en la página web de Consum (<a
          href="https://consum.gencat.cat/ca/consultes-i-reclamacions/reclamacio/"
          target="_blank"
          >enlace</a
        >).
      </p>
      <h2 class="mt-5 primary--text">14. Impuestos:</h2>
      <p>
        Los tributos que se devenguen en el desarrollo de este contrato serán
        satisfechos por las partes según Ley.
      </p>
      <h2 class="mt-5 primary--text">15. Régimen jurídico y normativa:</h2>
      <p class="mb-0">
        Los servicios contratados por el usuario se regirán por los Términos y
        Condiciones de Uso. Asimismo, resulta de aplicación la normativa
        española general y sectorial vigente en cada momento. Son de especial
        aplicación:
      </p>
      <ul>
        <li>
          La Ley 34/2002 de 11 de Julio sobre Servicios de la Sociedad de
          Información (LSSI).
        </li>
        <li>
          La Ley 15/1999 de 13 de Diciembre sobre Protección de Datos (LOPD).
        </li>
        <li>
          Real Decreto 1720/2007 de 21 de Diciembre sobre desarrollo de la LOPD.
        </li>
        <li>
          Reglamento UE 2016/679 sobre protección de las personas físicas
          (RGPD).
        </li>
        <li>
          La Ley 40/2002 de 14 de Noviembre sobre Regulación del Contrato de
          Aparcamiento.
        </li>
      </ul>
      <p class="mt-3">
        Las partes aceptan que, toda controversia derivada de este contrato,
        incluida cualquier cuestión relativa a su existencia, validez,
        terminación, interpretación o ejecución; se someterá para su resolución
        a mediación administrada por la Sección de Mediación de la Junta
        Arbitral de Consumo de Cataluña.
      </p>
      <p>
        Las partes aceptan que, caso que la mediación no resultará exitosa, la
        controversia se someterá a los Juzgados y Tribunales de la ciudad de
        Barcelona conforme a la Ley 1/2000 de 7 de Enero sobre Enjuiciamiento
        Civil.
      </p>
      <h2 class="mt-5 primary--text">16. Protección de datos:</h2>
      <p>
        NPU se obliga y garantiza la confidencialidad de los datos de carácter
        personal, e informa a sus usuarios que los datos, facilitados por los
        mismos, quedan incorporados a un fichero titularidad de NPU; cuya
        finalidad es proceder al mantenimiento, administración, ampliación,
        mejora y gestión de la relación contractual entre el usuario y NPU.
      </p>
      <p>
        NPU podrá utilizar los citados datos de carácter personal para solicitar
        información sobre la solvencia del usuario.
      </p>
      <p>
        NPU podrá ceder a terceros los datos de carácter personal cuando sea
        necesario para la correcta prestación del servicio.
      </p>
      <p class="mb-0 mt-3">
        Los datos de carácter personal contenidos en el fichero se utilizarán
        respetando las disposiciones contempladas en:
      </p>
      <ul>
        <li>
          La Ley 34/2002 de 11 de Julio sobre Servicios de la Sociedad de
          Información (LSSI).
        </li>
        <li>
          La Ley 15/1999 de 13 de Diciembre sobre Protección de Datos (LOPD).
        </li>
        <li>
          Real Decreto 1720/2007 de 21 de Diciembre sobre desarrollo de la LOPD.
        </li>
        <li>
          Reglamento UE 2016/679 sobre protección de las personas físicas
          (RGPD).
        </li>
        <li>
          Así como cualquier normativa que las complemente, modifique o
          sustituya.
        </li>
      </ul>
      <p class="mt-3">
        El usuario, cuando no manifieste su oposición en el proceso de registro,
        autoriza de forma expresa a NPU, u otra empresa de su grupo, para que
        está pueda remitirle información sobre productos y/o servicios
        relacionados con la movilidad.
      </p>
      <p>
        El usuario puede consultar con más detalle la Política de Privacidad de
        NPU en el siguiente enlace (<a href="/privacy-policy">Enlace</a>)
      </p>
      <h2 class="mt-5 primary--text">
        17. Procedimiento de registro en el servicio WSP:
      </h2>
      <p>
        Para poder usar el servicio WSP, el usuario deberá seguir los procesos
        de registro descritos a continuación, el proceso será función de la
        Tecnología de acceso que el usuario escoja:
      </p>
      <h3>Tecnología de acceso con etiqueta pasivo RFID:</h3>
      <ul>
        <li>
          Para referirnos a la etiqueta pasiva RFID usaremos las palabras
          pegatina o teletag. Esta pegatina es la “llave” que va a abrir la
          puerta de los aparcamientos WSP.
        </li>
        <li>
          El usuario podrá iniciar el registro a través de la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          El usuario proporcionará una dirección de correo electrónico válida y
          de la que sea titular.
        </li>
        <li>
          El usuario proporcionará un numero de móvil válido y del que sea
          titular.
        </li>
        <li>
          El usuario deberá validar el numero de móvil proporcionado,
          introduciendo el código que recibirá vía SMS al número proporcionado.
        </li>
        <li>
          El usuario deberá solicitar una pegatina para vincularla a su perfil.
          Para ello tiene dos (2) opciones: a) solicitar que la mandemos a la
          dirección postal que indique el usuario, o b) recogerla en las
          localizaciones indicadas.
        </li>
        <li>
          Cuando el usuario reciba la pegatina, este deberá activarla de modo
          que quede vinculada al usuario. Para ello deberá iniciar sesión, en la
          web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          o sus aplicaciones móviles para sistemas operativos Android y iOS; e
          introducir el código que aparece en la pegatina.
        </li>
        <li>
          Una vez activada la pegatina, el usuario debe colocarla en la luna de
          su vehículo tal y como se indica en las instrucciones proporcionadas
          por NPU en el folleto.
        </li>
        <li>
          En este punto, el usuario estará totalmente preparado para empezar a
          usar el servicio WSP.
        </li>
        <li>
          El usuario podrá dar de baja o pedir nuevas pegatinas a través de la
          web
          <a href="https://www.wesmartpark.com" target="blank"
            >www.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          La primera pegatina proporcionada en el proceso de registro no tiene
          coste para el usuario. Las siguientes pegatinas que solicité tendrán
          un coste de un (1) euro que se descontará del Saldo del usuario.
        </li>
        <li>
          El usuario puede tener tantas pegatinas activadas en su perfil de
          usuario como coches tenga.
        </li>
        <li>
          Es muy importante que el usuario, al activar cada pegatina, indique la
          matrícula del vehículo donde la podrá. Este punto es necesario para
          reportar las matrículas a las entidades encargadas de gestionar las
          zonas de tráfico restringido y evitar que el usuario reciba sanciones.
          Caso que, el usuario no haya introducido las matrículas correctamente
          o no las use correctamente, este exime a NPU de cualquier reclamación
          ante una sanción.
        </li>
      </ul>
      <br />
      <h3>Tecnología de acceso con bluetooth:</h3>
      <ul>
        <li>
          El usuario podrá iniciar el registro a través de la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          El usuario proporcionará una dirección de correo electrónico válida y
          de la que sea titular.
        </li>
        <li>
          El usuario proporcionará un numero de móvil válido y del que sea
          titular.
        </li>
        <li>
          El usuario deberá validar el numero de móvil proporcionado,
          introduciendo el código que recibirá vía SMS al número proporcionado.
        </li>
        <li>
          A las 8:00 de la mañana, cuando hayan transcurrido como mínimo 24
          horas desde su registro, el usuario recibirá una notificación push al
          número de teléfono proporcionado durante el registro, para comunicarle
          que ya dispone de llave electrónica y que puede usar los garajes de la
          red WSP.
        </li>
        <li>
          El usuario deberá habilitar los vehículos que utiliza a través de la
          web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS;
          proporcionando un “alias” para cada vehículo y su matrícula.
        </li>
        <li>
          Es muy importante que el usuario, al habilitar cada vehículo, indique
          su matrícula. Este punto es necesario para reportar las matrículas a
          las entidades encargadas de gestionar las zonas de tráfico restringido
          y evitar que el usuario reciba sanciones. Caso que, el usuario no haya
          introducido las matrículas correctamente o no las use correctamente,
          este exime a NPU de cualquier reclamación ante una sanción.
        </li>
      </ul>
      <h2 class="mt-5 primary--text">
        18. Procedimiento de contratación del servicio:
      </h2>
      <p class="mb-0">
        El proceso de contratación del servicio WSP por parte del usuario será
        como se describe a continuación:
      </p>
      <ul>
        <li>
          Entendemos como proceso de contratación de una Reserva o un Abono,
          cuando el usuario nos indica en qué lugar, día y hora de entrada desea
          aparcar en la red WSP.
        </li>
        <li>
          La contratación se puede hacer a través de la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS. Al
          mismo tiempo que conocemos los requisitos del usuario, comprobamos la
          disponibilidad de los Propietarios, permitiendo la creación o no de la
          Reserva o Abono en función de estos y, de las limitaciones que hayan
          fijado los Propietarios en su Perfil de Gestión, y/o las reservas
          previas que pudieran haber realizado otros usuarios.
        </li>
        <li>
          Las Reservas y Abonos se pueden contratar con antelación o al momento.
        </li>
        <li>
          El usuario podrá acceder al estacionamiento con una anterioridad
          máxima de treinta (30) minutos respecto a la hora indicada durante la
          contratación del servicio.
        </li>
        <li>
          En el caso de las Reservas, el usuario dispondrá de un margen de
          treinta (30) minutos posteriores a la hora indicada durante la
          contratación del servicio para poder acceder; transcurrido este tiempo
          la Reserva se cancelará automáticamente al entender que el usuario no
          va a acudir, debiéndola contratar de nuevo si quiere acceder al
          estacionamiento.
        </li>
      </ul>
      <h2 class="mt-5 primary--text">
        19. Procedimiento de uso de las instalaciones de estacionamiento:
      </h2>
      <p>
        Del mismo modo que el proceso de registro, el uso de las instalaciones
        de estacionamiento dependerá de la Tecnología de acceso que el usuario
        escoja:
      </p>
      <h3>Uso mediante Tecnología de acceso etiqueta pasivo RFID:</h3>
      <ul>
        <li>
          Para poder acceder al estacionamiento el usuario deberá disponer de
          una Reserva o Abono válido y de las Tecnologías de acceso.
        </li>
        <li>
          Para dirigirse al estacionamiento WSP contratado, el usuario podrá
          usar el sistema de navegación a través de las aplicaciones móviles
          para sistemas operativos Android y iOS.
        </li>
        <li>
          Para acceder al estacionamiento WSP, el usuario debe aproximarse con
          su vehículo a la entrada del estacionamiento; al hacerlo, la luz de la
          antena WSP instalada parpadeará en verde, indicando que se está
          detectando la pegatina del usuario y se está consultando sus permisos
          de acceso.
        </li>
        <li>
          Si la luz se queda en verde fijo, la puerta se abrirá y pondrá su
          Reserva o Abono en uso. Si la luz se queda en rojo fijo, la puerta no
          se abrirá, significando que el usuario no dispone de una Reserva o
          Abono válido.
        </li>
        <li>
          Cuando el usuario acceda al interior del estacionamiento WSP, deberá
          seguir las indicaciones de cartelería para localizar la Zona WSP donde
          están ubicadas las plazas gestionadas por el servicio WSP y aparcar en
          una de ellas. Caso que el estacionamiento tenga asignación de plaza,
          el usuario debe consultar la plaza asignada en la Pantalla de Control.
          Aparcar en una plaza no asignada o no gestionada por el servicio WSP
          puede conllevar la expulsión del servicio.
        </li>
        <li>
          Una vez estacionado el vehículo en la plaza WSP. El usuario podrá
          abandonar a pie el estacionamiento siguiendo las instrucciones de
          cartelería.
        </li>
        <li>
          Para recoger el vehículo del estacionamiento WSP, el usuario deberá
          seguir las indicaciones del detalle del estacionamiento; estas se
          pueden consultar en la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          Para salir del estacionamiento WSP el usuario deberá aproximarse a la
          salida del estacionamiento; al hacerlo la luz de la antena WSP
          instalada parpadeará en verde, indicando que se está detectando la
          pegatina del usuario.
        </li>
        <li>
          Si la luz se queda en verde fijo, la puerta se abrirá y pondrá su
          Reserva en cerrada. El consumo será deducido del Saldo del usuario, y
          se dará por finalizado el servicio contratado.
        </li>
      </ul>
      <br />
      <h3>Uso mediante Tecnología de acceso bluetooh:</h3>
      <ul>
        <li>
          Para poder acceder al estacionamiento el usuario deberá disponer de
          una Reserva o Abono válido y de las Tecnologías de acceso.
        </li>
        <li>
          Para dirigirse al estacionamiento WSP contratado, el usuario podrá
          usar el sistema de navegación a través de la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          Para acceder al estacionamiento WSP, el usuario debe aproximarse con
          su vehículo a la entrada del estacionamiento con la aplicación WSP
          abierta y en primer plano, el servicio de geolocalización activado y
          el servicio de bluetooth activado.
        </li>
        <li>
          Al acercarse a la puerta, se detectará el bluetooth del usuario,
          indicando que se está consultando sus permisos de acceso. Si los
          permisos son correctos la puerta se abrirá automáticamente y la
          Reserva o Abono se pondrá en uso. Caso que la puerta no se abra
          automáticamente, el usuario podrá solicitar la apertura pulsando el
          botón “Entrada vehículo” en la pantalla de la aplicación móvil WSP.
        </li>
        <li>
          Cuando el usuario acceda al interior del estacionamiento WSP, deberá
          seguir las indicaciones de cartelería para localizar la Zona WSP donde
          están ubicadas las plazas gestionadas por el servicio WSP y aparcar en
          una de ellas. Caso que el estacionamiento tenga asignación de plaza,
          el usuario debe consultar la plaza asignada en la aplicación móvil
          WSP. Aparcar en una plaza no asignada o no gestionada por el servicio
          WSP puede conllevar la expulsión del servicio.
        </li>
        <li>
          Una vez estacionado el vehículo en la plaza WSP. El usuario podrá
          abandonar a pie el estacionamiento siguiendo las instrucciones de
          cartelería.
        </li>
        <li>
          Para recoger el vehículo del estacionamiento WSP, el usuario deberá
          seguir las indicaciones del detalle del estacionamiento; estas se
          pueden consultar en la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          Para salir del estacionamiento WSP el usuario deberá aproximarse a la
          salida del estacionamiento con la aplicación WSP abierta, el servicio
          de geolocalización activado y el servicio de bluetooth activado.
        </li>
        <li>
          Cuando el usuario este delante de la puerta de salida, deberá pulsar
          el botón “Salida Vehículo” en la pantalla de la aplicación móvil WSP.
          Al hacerlo, la puerta se abrirá y la Reserva se pondrá en cerrada. El
          consumo será deducido del Saldo del usuario, y se dará por finalizado
          el servicio contratado.
        </li>
      </ul>
    </v-container>
  </v-window>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'TermsOfUseDefault',
  methods: {
    onWaypoint({ going, direction, el }) {
      if (going === this.$waypointMap.GOING_IN) {
        EventBus.$emit(keys.eventShowToolbar, { offset: el.offsetTop });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#landing-section {
  height: calc(100vh);
}
#landing-section #slogan {
  font-weight: bold;
}
.xs #landing-section #slogan {
  font-size: 4vh;
  line-height: 6vh;
}
.sm #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.md #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.lg #landing-section #slogan {
  font-size: 7vh;
  line-height: 7vh;
}

.xs #landing-section #subslogan {
  font-size: 2vh;
  line-height: 2vh;
}
.sm #landing-section #subslogan {
  font-size: 3vh;
  line-height: 3vh;
}
.md #landing-section #subslogan {
  font-size: 3vh;
  line-height: 3vh;
}
.lg #landing-section #subslogan {
  font-size: 4vh;
  line-height: 4vh;
}

#landing-section #landing-section-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}
#landing-section .v-card {
  margin-top: -10%;
}
</style>
